export default __webpack_public_path__ + "assets/pdf/FT_VG38.7c1f8fd6.pdf";